import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';
import { ApplyBoundEnum } from '@Policy/utils/types';

const cfg = {
  policySubType: 1,
  policyType: 82,
  tmVirusscans: {
    vsApplyBound: 7,
    vsAdditionalThreatsActionType: 109,
    vsAllThreatsActionType: 2,
    vsRansomwareActionType: 109,
    vsMaliciousActionType: 109,
    vsMassingMailingActionType: 103,
    vsPackersActionType: 109,
    vsUncleanableThreatsActionType: 109,
    vsVirusesActionType: 109,
    vsWormsTrojansActionType: 10,
  },

  tmFileblockings: { fbApplyBound: 1 },
  tmWebthreatprotections: {
    wtpActionType: 109,
    wtpActionBlockedUrl: 109,
    wtpFileAction: 251,
    wtpUrlcvEnabled: 1,
    wtpExtractAttachmentUrl: 1,
    wtpApplyBound: ApplyBoundEnum.all,
  },

  tmDdafilters: {
    ddaActionHighRisk: 109,
    ddaActionMediumRisk: 109,
  },

  tmAntispamfilters: {
    asActionBec: 6,
    asActionOthers: 6,
    asActionPhish: 109,
    asActionRansome: 109,
    asActionMalicious: 109,
    asActionBlockedSender: 109,
    asActionScam: 109,
    wsNotifyRecipientActionType: 5,
    asGreyMailEnabled: 0,
    asGrayEmailMmlEnabled: 0,
    asGrayEmailForumEnabled: 0,
    asGrayEmailBulkEnabled: 0,
    asGrayEmailSocialNetworkEnabled: 0,
  },
};
export function getExchangeOutboundTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.EX.tmAntispamfilters.asDisclaimerSuspiciousSender',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmDdafilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleCompromisedUserSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleCompromisedUserMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderMessage',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleAdministratorSubject',
    'policy.policyTemplate.EX.tmAntispamfilters.notification.ntfWritingStyleAdministratorMessage',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
